import { FetchAllPagesConfig } from './fetchAllPages.types';

export default async function fetchAllPages<Response, Item, Params>(
  config: FetchAllPagesConfig<Response, Item, Params>,
): Promise<Item[]> {
  const {
    fetchPage,
    initialParams,
    getItems,
    getNextParams,
    signal,
  } = config;

  const allItems: Item[] = [];
  let params: Params | null | undefined = initialParams;

  while (params) {
    const response = await fetchPage(params, signal);
    allItems.push(...getItems(response));

    params = getNextParams({
      response,
      params,
      allItems,
    });
  }

  return allItems;
}
